import UrgencyStaleIcon from '@mui/icons-material/Schedule';
import UrgencyHighIcon from 'assets/urgency-high.svg?react';
import UrgencyMediumIcon from 'assets/urgency-medium.svg?react';
import UrgencyStandardIcon from 'assets/urgency-standard.svg?react';
import UrgencyUrgentIcon from 'assets/urgency-urgent.svg?react';
import { GeoEventUrgencyLevel } from 'features/geoEvents/geoEvent.types';

type UrgencyIconProps = {
  urgency: GeoEventUrgencyLevel;
  size: number;
};

export const UrgencyIcon = (props: UrgencyIconProps): JSX.Element => {
  const { urgency, size } = props;

  switch (urgency) {
    case GeoEventUrgencyLevel.Stale:
      return <UrgencyStaleIcon color="disabled" sx={{ fontSize: size }} />;
    case GeoEventUrgencyLevel.Medium:
      return <UrgencyMediumIcon width={size} height={size} />;
    case GeoEventUrgencyLevel.High:
      return <UrgencyHighIcon width={size} height={size} />;
    case GeoEventUrgencyLevel.Urgent:
      return <UrgencyUrgentIcon width={size} height={size} />;
    default:
      return <UrgencyStandardIcon width={size} height={size} />;
  }
};
